import React from "react";
import { Popover, MenuList, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ViewSelectorPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onViewChange: (view: string) => void;
}

const ViewSelectorPopover: React.FC<ViewSelectorPopoverProps> = ({
  anchorEl,
  onClose,
  onViewChange,
}) => {
  const { t } = useTranslation();

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      PaperProps={{
        sx: {
          backgroundColor: "#fff",
          borderRadius: 2,

          color: "#5E5873",
          border: "1px solid #E9EAEC",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          overflowX: "hidden",
        },
      }}
    >
      <MenuList>
        <MenuItem onClick={() => onViewChange("dayGridMonth")}>
          {t("calendar.month")}
        </MenuItem>
        <MenuItem onClick={() => onViewChange("timeGridWeek")}>
          {t("calendar.week")}
        </MenuItem>
        <MenuItem onClick={() => onViewChange("timeGridDay")}>
          {t("calendar.day")}
        </MenuItem>
      </MenuList>
    </Popover>
  );
};

export default ViewSelectorPopover;
